import React from 'react';
import './say.css';
import { speakSegment } from '../speakSegment';
import { segmentPhonemes } from '../../phonemes/segmentPhonemes';
import { getFeaturesForOne } from '../../phonemes/ipa';

interface Say2Props {
  /** what to show and say */
  readonly children: string;
  /** extra info to show in parens */
  readonly alt?: string;
}

/** shows a phoneme segment you can click on to hear it spoken */
export function Say2(props: Say2Props) {
  function onClick() {
    const ipa = props.children.replaceAll('/', '');
    const segments = segmentPhonemes(ipa, 'ipa', 'en-aff');
    if (segments.phonemes.length > 1) {
      const features = getFeaturesForOne(segments.phonemes[1].phoneme);
      if (features.includes('vowel') && !features.includes('non-syllabic')) {
        // check to see if we need to turn /eɪ/ into /eɪ̯/
        const say = features.includes('non-syllabic') ? ipa : ipa + '\u032F';
        speakSegment(say);
        return;
      } else if (features.includes('choice') && segments.phonemes.length === 3) {
        // e.g., /o~u/
        speakSegment(segments.phonemes[0].phoneme);
        speakSegment(segments.phonemes[2].phoneme);
        return;
      }
    }

    speakSegment(ipa);
  }

  const playButton = '\u23f5';
  return (<span onClick={onClick} className='say' style={{ whiteSpace: 'nowrap' }}>
    {playButton}
    {props.children}
    {props.alt ? ` (${props.alt})` : ''}
  </span>);
}
